import { render } from "./AsDivider.vue?vue&type=template&id=7bea9ee7"
const script = {}

import "./AsDivider.vue?vue&type=style&index=0&id=7bea9ee7&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__